//Library imports
import { useEffect } from "react";
import { RootState } from "store";
import { useSelector } from "react-redux";
import styled from "styled-components";

//Local Imports
import { serializeArticle } from "../../../Content/WhatsHappeningNow/utils";
import BlogItemThree from "modules/Common/Components/BlogItemThree";
import PrevSentIcon from "../../../../assets/img/Campaign/prev-sent-icon.svg";
import ListPlaceholder from "modules/Content/WhatsHappeningNow/Components/ListPlaceholder";
import EmptyTabInfo from "modules/Content/Shared/EmptyTabInfo";
import { getPreviouslySentContent } from "../actions";

interface PropsType {}

const PreviouslySent = (props: PropsType) => {
  const prevSentList: any = useSelector((state: RootState) => state.assets.previouslySentEdition);
  const prevSentListLoading: boolean = useSelector(
    (state: RootState) => state.assets.previouslySentEditionLoading
  );

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const formatDate = (date: any) => {
    console.log("prevSentList");
    let d = new Date(date);
    console.log("prevSentList", monthNames[d.getMonth()] + d.getDay() + " Edition");
  };
  // const serializedArticles: IArticlesItem[] = serializeArticles(prevSentList);
  useEffect(() => {
    window.scroll(0, 0);

    let search = window.location.search;
    const params = new URLSearchParams(search);
    const assetId = params.get("campaign_id");
    getPreviouslySentContent(assetId);
  }, []);

  return (
    <Wrapper>
      <h3 className="heading">
        <img src={PrevSentIcon} alt="heading" className="padding-right-sm" />
        Content previously sent with this campaign:
      </h3>
      {prevSentListLoading && <ListPlaceholder loading={prevSentListLoading} />}
      {prevSentListLoading === false && prevSentList.length === 0 && (
        <EmptyTabInfo description="You haven't sent this Digest to anyone yet, once you do, the content you sent out will be listed here so you can see it and curate it to other emails easily." />
      )}
      {prevSentListLoading === false && (
        <div className="content-wrapper margin-bottom-lg">
          {prevSentList?.length > 0 &&
            prevSentList.map((li: any, index: number) => {
              return (
                <div key={index} className="date-editions">
                  <div className="date-title">
                    {monthNames[new Date(li.sent_date.replace(/-/g, "/")).getMonth()] +
                      " " +
                      new Date(li.sent_date.replace(/-/g, "/")).getDate() +
                      " Edition: "}
                  </div>
                  {li.articles.length > 0 &&
                    li.articles.map((articleItem: any, index: number) => {
                      const article: any = serializeArticle(articleItem);
                      return (
                        <div className="custom-blogThreeStyle padding-bottom-lg" key={index}>
                          {/* <DraggableBox blogItem={article}> */}
                          <BlogItemThree
                            key={article.id}
                            articleId={article.id}
                            title={article.title}
                            imgUrl={article.image_url}
                            publishDate={article.publish_date}
                            website={article.website}
                            description={article.description}
                            entities={article.entities}
                            link={article.link}
                            isCurated={article.is_curated}
                            isCMS={article.is_cms}
                            isFav={article.is_favourite}
                            addBlog={true}
                            status="Sent"
                          />
                          {/* </DraggableBox> */}
                        </div>
                      );
                    })}
                </div>
              );
            })}
        </div>
      )}
    </Wrapper>
  );
};

export default PreviouslySent;

const Wrapper = styled.div`
  .heading {
    color: #424b50;
    display: flex;
    font-size: 30px;
    font-weight: 600;
    font-family: "Roboto Slab", serif;
    margin-bottom: 0;
    .heading-img {
    }
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 22px;
      margin-top: 10px;
    }
  }
  .content-wrapper {
    .date-editions {
      padding-top: 13px;
      .date-title {
        color: #67696a;
        font-size: 22px;
        font-family: "robotomedium", sans-serif;
        margin-bottom: 18px;
      }
      .custom-blogThreeStyle {
        .wrapper {
          background-color: #fff;
          padding: 10px 20px;
          border-radius: 8px;
        }
      }
    }
  }
`;
